import { ComponentProps } from 'react'

import { AvatarStackTopToBottom } from '@/components/TailwindUI/AvatarStack'
import cn from '@/utilities/cn'

type SharedWithProps = {
  sharedWith: string[]
  isLoading: boolean
  maxIcons?: number
  isOverflowHidden?: boolean
}
export default function SharedWithDiv({
  sharedWith = [],
  isLoading = false,
  maxIcons = 3,
  className,
  isOverflowHidden = true,
  ...rest
}: SharedWithProps & ComponentProps<'div'>) {
  const maxSharedWith = sharedWith.slice(0, maxIcons)
  return isLoading ? (
    <div className="fade-in animate-pulse text-zinc-400 line-clamp-1">...</div>
  ) : (
    <div className={cn(`flex ${isOverflowHidden && 'overflow-hidden'} transition-all`, className)} {...rest}>
      <AvatarStackTopToBottom userIds={maxSharedWith} isOverflowHidden={isOverflowHidden} />
    </div>
  )
}
